import type { FC } from 'react';
import { msg } from '@gonfalon/messages/msg';

import { CopyButton } from '../../internal/components/AgentInsights/components/CopyButton';

import { SpanDetailsIconButton } from './internal/SpanDetailsIconButton';

import { feedback } from '../../internal/components/conversation/ConversationChrome.css';

export const MessageFeedback: FC<{
  copyText?: string;
  onCopy?: () => void;
  onShowDetails?: () => void;
}> = ({ copyText, onCopy, onShowDetails }) => {
  if (!copyText && !onShowDetails) {
    return null;
  }

  return (
    <div className={feedback} role="group" aria-label={msg('vega.conversation.replyActions')}>
      {copyText ? (
        <CopyButton
          redesign
          text={copyText}
          label={msg('vega.conversation.copyReplyLabel')}
          successTitle={msg('vega.conversation.copyReplySuccess')}
          onCopy={onCopy}
        />
      ) : null}
      {onShowDetails ? <SpanDetailsIconButton onPress={onShowDetails} /> : null}
    </div>
  );
};
